module.exports = __webpack_public_path__ + "public/Icons/wheelchair.svg?ae88c3a4";